import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Button, Image, Text
} from 'components/ui';
import {
    colors, mediaQueries, radii, shadows, space
} from 'style/config';
import BenefitIconList from 'components/Content/BeautyInsider/BeautyInsiderBenefits/BenefitIconList';
import Empty from 'constants/empty';
import getBenefitsViewState from 'components/Content/BeautyInsider/BeautyInsiderBenefits/benefitsViewState';
import mediaUtils from 'utils/Media';

const { Media } = mediaUtils;
const getSection = props => getBenefitsViewState(props).creditCardSection;
const getHref = link => link?.href || link?.url || link?.targetUrl;
const getLabel = link => link?.label || link?.text || link?.title;
const CREDIT_CARD_ASSET_SRC = '/img/ufe/credit-card/cc-holder-benefits.png';

/**
 * Renders the U.S. credit-card-holder Benefits section and card details CTA.
 */
const CreditCardBenefitsSection = props => {
    const section = getSection(props);
    const benefits = section?.benefits || Empty.Array;
    const action = section?.action || section?.link;
    const actionHref = getHref(action);
    const actionLabel = getLabel(action);

    if (!section?.title || !benefits.length || !actionHref || !actionLabel) {
        return null;
    }

    return (
        <Box
            is='section'
            marginBottom={[4, 5]}
            css={styles.card}
            data-at={Sephora.debug.dataAt('bi_benefits_credit_card')}
        >
            <Media lessThan='md'>
                <Box
                    css={styles.badge}
                    data-at={Sephora.debug.dataAt('bi_benefits_credit_card_asset')}
                >
                    <Image
                        src={CREDIT_CARD_ASSET_SRC}
                        size={50}
                        alt=''
                    />
                </Box>
            </Media>
            <Text
                is='h2'
                fontWeight='bold'
                fontSize={['md', 'lg']}
                lineHeight='tight'
                marginBottom={4}
                children={section.title}
            />
            <BenefitIconList
                benefits={benefits}
                columns={1}
            />
            <Button
                is='a'
                href={actionHref}
                variant='secondary'
                hasMinWidth={true}
                marginTop={4}
                width={['100%', 'auto']}
                data-at={Sephora.debug.dataAt('bi_benefits_credit_card_cta')}
                children={actionLabel}
            />
        </Box>
    );
};

const styles = {
    card: {
        backgroundColor: colors.white,
        borderRadius: radii[2],
        boxShadow: shadows.light,
        padding: space[4],
        [mediaQueries.sm]: {
            padding: space[5]
        }
    },
    badge: {
        display: 'block',
        marginBottom: space[3]
    }
};

export default wrapFunctionalComponent(CreditCardBenefitsSection, 'CreditCardBenefitsSection');
